import apiClient from "../../../lib/api_client";

// Section of the portal a design was added from. Every card that goes into
// the cart is stamped with it (`addSection`, `addedAt`) right where it is
// added - the cart row itself is the record, nothing extra is kept alongside
// it. Counted at order time straight off the cart that was ordered.
export const DESIGN_SECTIONS = {
  CATEGORIES: "Categories",
  RELEVANT_SET: "Relevant Set",
  RECOMMENDED: "Recommended Designs",
  SEARCH: "Search",
  SCAN: "Scan",
  COLLECTIONS: "Collections",
  OTHER: "Other",
};

const KNOWN_SECTIONS = Object.values(DESIGN_SECTIONS);

// Anything unrecognised is counted as Other rather than being dropped.
export const sectionFromSource = (source) =>
  KNOWN_SECTIONS.includes(source) ? source : DESIGN_SECTIONS.OTHER;

// One row per design in the cart that was ordered, read off the section each
// row was stamped with when it was added.
export const buildDesignStats = (cartItems = []) =>
  (cartItems || [])
    .filter((item) => item?.styleNumber)
    .map((item) => ({
      styleNumber: item.styleNumber,
      section: sectionFromSource(item?.addSection || item?.source),
      count: item?.quantityData?.length || item?.quantity || 1,
      categoryName: item?.categoryName || "",
      subCategoryName: item?.subCategoryName || "",
      addedAt: item?.addedAt || null,
    }));

export const recordDesignStats = async (payload) => {
  const res = await apiClient.post("/designAddStats", payload);
  return res?.data?.data || null;
};

export const fetchDesignStats = async (params = {}) => {
  const res = await apiClient.get("/designAddStats", { params });
  return res?.data?.data || null;
};
